import Parcel from '../../Parcel';
import ResponseError from "../../../../bootstrap/api/ResponseError";
import ResponseResult from "../../../../bootstrap/api/ResponseResult";
import filtersToEndpoint from "../../hydrate/filtersToEndpoint";
import ordersToEndpoint from "../../hydrate/ordersToEndpoint";

export default class ArticleListParcel extends Parcel {

    constructor(
        {
            search = null,
            filters = null,
            filtersConfig = null,
            orders = null,
            limit = null,
            offset = null,
            refNames = null,
        }
    ) {
        super();

        this.setEndpoint('/api/article/list');
        this.setRequestMethod('GET');

        const searchFilters = [];

        if (search !== null) {
            searchFilters.push([
                {field: 'id', operator: '=', value: search},
                {field: 'name', operator: 'contain', value: search},
            ]);
        }

        const searchFiltersConfig = {
            id: {type: 'number'},
            name: {type: 'string'},
        };

        if (searchFilters.length > 0) {
            if (filters !== null && filtersConfig !== null) {
                filters = [...filters, ...searchFilters];
                filtersConfig = {...filtersConfig, ...searchFiltersConfig};
            } else {
                filters = searchFilters;
                filtersConfig = searchFiltersConfig;
            }
        }

        if (filters !== null && filtersConfig !== null) {
            this.setQueryParam('filters', filtersToEndpoint(filters, filtersConfig));
        }

        if (orders !== null) {
            this.setQueryParam('orders', ordersToEndpoint(orders));
        }

        if (limit !== null) {
            this.setQueryParam('limit', limit);
        }

        if (offset !== null) {
            this.setQueryParam('offset', offset);
        }

        if (refNames !== null) {
            this.setQueryParam('refNames', refNames);
        }
    }

    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }

    parseResponseResult(rawResult) {
        if (rawResult.error) {
            return new ResponseResult(null, new ResponseError(rawResult.error.message));
        }

        return new ResponseResult(rawResult.data, null);
    }
}
